module.exports = __webpack_public_path__ + "static/media/icon-topical-worksheet.43c6e319.svg";